export const RESPONDERS_FIELD_KEY = 'responders-field';
export const MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';

// MS TEAMS
export const MSTEAM_SCOPE_TYPE = 'jsm-chat-ops-msteams-integration';
export const MSTEAM_SCOPE_ID = 'cloudId';
export const MSTEAM_CHAT_TYPE = 'msteams';
export const MSTEAM_APP_TYPE = 'jsm-msteams-app';
export const MSTEAM_ENTITY_TYPE = 'jsm-project';

// ZOOM
export const ZOOM_SCOPE_TYPE = 'jsm-chat-ops-zoom-integration';
export const ZOOM_SCOPE_ID = 'cloudId';
export const ZOOM_CHAT_TYPE = 'zoom';
export const ZOOM_APP_TYPE = 'jsm-zoom-app';
export const ZOOM_ENTITY_TYPE = 'jsm-project';

// SLACK
export const SLACK_ENTITY_TYPE = 'jsm-project';
export const SLACK_APP_TYPE = 'jsm-it-service-desk';

export type AppType = 'jsm-it-service-desk' | 'jsm-zoom-app' | 'jsm-msteams-app';
